import { Maybe } from 'graphql/jsutils/Maybe'

import { LabelConnectionFragment } from '../app/utils/labelsTypes'
import { PROPERTY_TYPES } from './drmTypes'
import { NalezenaAdresa, RzpSubjectTypeKey } from './rzpTypes'

export enum PROPERTY_TAB_KEYS {
  NOTE = 'poznamky',
  OWNERSHIP = 'vlastnictvi',
  TIMELINE = 'casova-osa',
  SUBJECT = 'subjekty-na-adrese',
  PROCEEDING = 'rizeni',
  PRICE_ESTIMATE = 'cenovy-odhad',
  BUYBACK = 'kalkulace-nabidky',
  RISY = 'detail-obce',
  WATCHDOG = 'hlidac',
  AUCTION = 'drazba',
  PRICE = 'cenove-udaje',
}

export const PROPERTY_TABS = {
  [PROPERTY_TAB_KEYS.NOTE]: 'Poznámky',
  [PROPERTY_TAB_KEYS.OWNERSHIP]: 'Vlastnictví',
  [PROPERTY_TAB_KEYS.TIMELINE]: 'Časová osa',
  [PROPERTY_TAB_KEYS.PROCEEDING]: 'Řízení',
  [PROPERTY_TAB_KEYS.PRICE_ESTIMATE]: 'Cenový odhad',
  [PROPERTY_TAB_KEYS.BUYBACK]: 'Kalkulace nabídky',
  [PROPERTY_TAB_KEYS.SUBJECT]: 'Subjekty',
  [PROPERTY_TAB_KEYS.RISY]: 'Informace o obci',
  [PROPERTY_TAB_KEYS.WATCHDOG]: 'Hlídač',
  [PROPERTY_TAB_KEYS.AUCTION]: 'Dražby',
  [PROPERTY_TAB_KEYS.PRICE]: 'Cenové údaje',
}

export interface PropertyDetailSubjectsTableItem {
  id?: string
  key: string
  typ: RzpSubjectTypeKey
  nazev: string
  vzdalenost: number | null
  adresa?: string | null
  sidlo?: string | null
  nalezenaAdresa?: NalezenaAdresa | null
  kodAdresnihoMista?: number | null
  uniquePersonKey: string
  ico?: string
  aktualni: boolean
  angazovaneOsoby?: PropertyDetailSubjectsTableItem[]
  datumOd?: string
  datumDo?: string
  angazma?: {
    datumDo?: string | null
    datumOd?: string | null
    nazevAngazma?: string | null
    predmetPodnikani?: string | null
  }[]
  match?: string
  datumNarozeni?: string
  predmetPodnikani?: string
  velikostPodilu?: number
}

export interface PropertyDetailLabelData {
  id?: string
  propertyId: string
  propertyLabelId?: string
  type: PROPERTY_TYPES
  name: string
  cadastralCode: string
  cadastralName: string
  lv: string
}

export interface PropertyLabel {
  id: string
  propertyId: string
  propertyLv: string
  propertyName: string
  propertyType: PROPERTY_TYPES
  propertyCadastralName: string
  propertyCadastralCode: string
  createdAt: string
  labels?: LabelConnectionFragment
}

export interface LabelConnection {
  id?: string | null
  labelByLabelId?: Label | null
}

export type PropertyLabelConnection = Maybe<{
  id?: string | null
  labelByLabelId?: Maybe<{
    id: string
  }>
}>

export interface Label {
  description?: string
  iconKey: string
  colorKey: string
  id: string
  name: string
}

export interface PropertyLabelData {
  propertyId: string
  propertyName: string
  propertyType: PROPERTY_TYPES
  propertyCadastralName: string
  propertyCadastralCode: string
  propertyLv: string
  propertyLabelId?: string
  createdAt?: Date
}

export interface PropertyLabelInputData extends PropertyLabelData {
  accountId: string
  accountUserId: string
}

export type TransformedPropertyLabelDataItem = {
  labels: {
    nodes: LabelConnection[]
    totalCount: number | null
  }
  propertyData: PropertyLabelData
}

export interface TransformedPropertyLabelData {
  [propertyId: string]: TransformedPropertyLabelDataItem
}
